import React, { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { API_BASE_URL } from "../../../config";
import { useHistory } from "react-router-dom";

const OthersAppraisalList = () => {
  const history = useHistory();   // ✅ INSIDE component
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${API_BASE_URL}/appraisal/others-list`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      setRows(res.data.data);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  const columns = [
    {
      name: "Employee Name",
      selector: (row) => row.employee_name,
      sortable: true,
    },
    {
      name: "Employee ID",
      selector: (row) => row.employee_id,
    },
    {
      name: "Sent On",
      selector: (row) => row.sent_date,
    },
    {
      name: "Department",
      selector: (row) => row.department,
    },
    {
      name: "Self Score",
      cell: (row) =>
        row.self_score ? (
          <button
            className="btn btn-outline-success btn-sm"
            onClick={() =>
              history.push(`/SelfAppraisalScore/${row.self_summary_id}`)
            }
          >
            {row.self_score}
          </button>
        ) : (
          "--"
        ),
    },
    {
      name: "Action",
      cell: (row) => {
        if (row.action === "evaluate" || row.action === "view") {
          return (
           <button
  className={`btn btn-sm ${
    row.action === "evaluate" ? "btn-primary" : "btn-primary"
  }`}
  onClick={() =>
    history.push(`/appraisal/evaluate/${row.request_id}`)
  }
>
  {row.action === "evaluate" ? "Evaluate" : "View"}
</button>

          );
        }
        return <span className="text-danger">Date Expired</span>;
      },
    },
    {
      name: "Your Score",
      selector: (row) => row.your_score || "--",
    },
  ];

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
          <i className="fa fa-star mr-2" style={{ fontSize: "20px" }} />
          Others Appraisal List
        </h3>
      </div>
      <div className="card-body">
        <DataTable
          columns={columns}
          data={rows}
          progressPending={loading}
          pagination
          highlightOnHover
        />
      </div>
    </div>
  );
};

export default OthersAppraisalList;
